import { SHOW_POPUP, HIDE_POPUP } from '../actions/type'

const initState = {
    isShow: false,
    textHeader: '',
    textBody: '',
    textButton: '',
    action: {}
}

const popup = (state = initState, action) => {
    const { payload, type } = action
    switch (type) {
        case SHOW_POPUP:
            return { ...state, ...payload }
        case HIDE_POPUP:
            return { ...state, ...payload }
        default:
            return state;
    }
}

export default popup